
import { NavLink } from "react-router-dom";

function Sidebar() {

    const menuItems = [
        { path: "/dashboard", label: "Dashboard", end: true },
        { path: "/dashboard/users", label: "Users" },
        { path: "/dashboard/settings", label: "Settings" },
        { path: "/dashboard/banks", label: "Banks" },
        { path: "/dashboard/buyers", label: "Buyers" },
        { path: "/dashboard/despatcho", label: "Despatcho" },
        { path: "/dashboard/ports", label: "Ports" },
        { path: "/dashboard/redex", label: "Redex" },
        { path: "/dashboard/shipping", label: "Shipping" },
        { path: "/dashboard/supplier", label: "Supplier" },
        { path: "/dashboard/material", label: "Materials" },
        { path: "/dashboard/transporter", label: "Transporters" },
        { path: "/dashboard/ledger", label: "Ledger" },
        { path: "/dashboard/bank/statement", label: "Bank Statement" },
        { path: "/dashboard/summary", label: "Summary" },
        { path: "/dashboard/restricted", label: "Restricted" }
    ];

    return (

        <div className="sidebar-wrapper">

            {/* Fixed Sidebar Heading */}
            <div className="sidebar-header">
                <h4 className="text-center mb-0">
                    Dashboard
                </h4>
            </div>

            <hr className="text-secondary mx-3" />

            {/* Scrollable Menu */}
            <div className="sidebar-menu">

                <ul className="nav flex-column px-2">

                    {menuItems.map((item, index) => (

                        <li className="nav-item mb-2" key={index}>

                            <NavLink
                                to={item.path}
                                end={item.end}
                                className={({ isActive }) =>
                                    `nav-link px-3 py-2 rounded sidebar-link ${
                                        isActive ? "active" : ""
                                    }`
                                }
                            >

                                {item.label}

                            </NavLink>

                        </li>

                    ))}

                </ul>

            </div>

        </div>
    );
}

export default Sidebar;
